export default "__VITE_ASSET__B3URB9ps__"